const ITEMS = [
  '24/7 Call Answering',
  'Instant Lead Capture',
  'Appointment Booking',
  'Automated Follow-Ups',
  'Human-Like Voice',
  'Customer Feedback',
];

export const MarqueeBand = () => (
  <section
    className="marquee overflow-hidden border-y border-brand-line/70 bg-brand-iceSoft py-5"
    aria-label="CapableBee capabilities"
    data-testid="capability-marquee"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <ul key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <li
              key={item}
              className="flex items-center gap-3 whitespace-nowrap px-8 text-sm font-bold tracking-wide text-brand-body/80"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-brand-honey" aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
      ))}
    </div>
  </section>
);
